import SubmissionError from '../../../../error/SubmissionError'
import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'

export const reset = ({ commit }) => {
  commit(types.RESET)
}

export const retrieve = ({ commit }, id) => {
  commit(types.SET_ERROR, '')
  commit(types.TOGGLE_LOADING)

  return fetch(id)
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_RETRIEVED, data)
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_ERROR, e.message)
    })
}

export const getLanguages = ({ commit }, page = 'languages') => {
  commit(types.SET_ERROR, '')
  commit(types.TOGGLE_LANGUAGES_LOADING)

  fetch(page)
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LANGUAGES_LOADING)
      commit(types.SET_LANGUAGES, data['hydra:member'])
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_ERROR, e.message)
    })
}

export const update = ({ commit, state }) => {
  commit(types.SET_ERROR, '')
  commit(types.TOGGLE_LOADING)

  return fetch(state.retrieved['@id'], {
    method: 'PUT',
    headers: new Headers({ 'Content-Type': 'application/ld+json' }),
    body: JSON.stringify(state.retrieved)
  })
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_UPDATED, data)
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING)

      if (e instanceof SubmissionError) {
        commit(types.SET_VIOLATIONS, e.errors)
        // eslint-disable-next-line
        commit(types.SET_ERROR, e.errors._error)

        return
      }

      // eslint-disable-next-line
      commit(commit(types.SET_ERROR, e.errors._error))
    })
}

export const updateRetrieved = ({ commit }, updated) => {
  commit(types.UPDATE_RETRIEVED, updated)
}

export const updateTranslation = ({ commit }, updated) => {
  commit(types.UPDATE_TRANSLATION, updated)
}

export const storeTranslation = ({ commit, state }, code) => {
  commit(types.SET_ERROR, '')
  commit(types.TOGGLE_TRANSLATION_LOADING)

  let data = {
    id: state.translation.id,
    name: state.translation.name,
    description: state.translation.description
  }

  return fetch(state.retrieved['@id'], {
    method: 'PUT',
    headers: new Headers({ 'Accept-Language': code }),
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_TRANSLATION_LOADING)
      commit(types.SET_TRANSLATION, data)
    }).catch((e) => {
      commit(types.SET_ERROR, e.message)
    })
}

export const getTranslation = ({ commit, state }, code) => {
  commit(types.SET_ERROR, '')
  commit(types.TOGGLE_TRANSLATION_LOADING)

  return fetch(state.retrieved['@id'], {
    method: 'GET',
    headers: new Headers({ 'Accept-Language': code })
  })
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_TRANSLATION_LOADING)
      commit(types.SET_TRANSLATION, data)
    }).catch((e) => {
      commit(types.SET_ERROR, e.message)
    })
}
